import { apiEndPoints } from '../../common/api.endPoints';

export const getDoctorsEndPoint = (
  applicationId: number,
  taskId: number,
): string => {
  return `${apiEndPoints.applications}/${applicationId}/task/${taskId}/doctors`;
};

export const searchDoctorsEndPoint = (
  applicationId: number,
  taskId: number,
  query: string,
): string => {
  return `${apiEndPoints.applications}/${applicationId}/task/${taskId}/doctors-search/${query}`;
};

export const placeAPSOrderEndPoint = (
  applicationId: number,
  taskId: number,
): string => {
  return `${apiEndPoints.applications}/${applicationId}/task/${taskId}/aps-order`;
};

export const placeEhrOrderEndPoint = (
  applicationId: number,
  taskId: number,
): string => {
  return `${apiEndPoints.applications}/${applicationId}/task/${taskId}/ehr`;
};

export const placeLabPiqOrderEndPoint = (
  applicationId: number,
  taskId: number,
): string => {
  return `${apiEndPoints.applications}/${applicationId}/task/${taskId}/labpiq`;
};
